import { Box, Button, IconButton, Modal, Typography } from "@mui/material";
import { Dispatch, SetStateAction } from "react";
import CloseIcon from "@mui/icons-material/Close";
import useTranslation from "../hooks/traslation";

type props = {
  openModal: boolean;
  setOpenModal: Dispatch<SetStateAction<boolean>>;
  text: string;
  handleSubmit: () => void;
};
export const ConfirmationModal = ({
  openModal,
  setOpenModal,
  text,
  handleSubmit,
}: props) => {
  const transation = useTranslation();
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "#ffff",
    // border: "1px solid #fff",
    boxShadow: 24,
    p: 6,
    borderRadius: 3,
    outline: "none",
  };
  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
      className="logout_mdl"
    >
      <Box sx={style}>
        <IconButton
          onClick={() => setOpenModal(false)}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#252525",
          }}
        >
          <CloseIcon />
        </IconButton>
        <Typography
          id="modal-modal-title"
          variant="h6"
          component="h2"
          sx={{ textAlign: "center", fontSize: "20px", color: "#1d2b28" }}
        >
          {text}
        </Typography>
        <div
          style={{
            display: "flex",
            gap: "30px",
            justifyContent: "center",
            paddingTop: "20px",
          }}
        >
          <Button
            className="btn btn_primary"
            sx={{ minWidth: "100px" }}
            // sx={{ color: "#252525", border: "1px solid #252525" }}
            onClick={() => {
              setOpenModal(false);
              handleSubmit();
            }}
          >
            {transation.globals.Yes}
          </Button>

          <Button
            className="btn btn_primary"
            sx={{ minWidth: "100px" }}
            // sx={{ color: "#252525", border: "1px solid #252525" }}
            onClick={() => setOpenModal(false)}
          >
            {transation.globals.No}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
